<template>
  <div>
    <vuedraggable
      @end="draggableEnd"
      tag="div"
      draggable=".draggable-item"
      class="row "
      v-if="!disabled"
    >
      <div
        v-for="(item, index) in listDetail"
        :key="item.evgPackingSchemeGroupDetailCode"
        class="draggable-item col move fg-0"
      >
        <div class="desc-img">
          <el-image
            :src="
              item.displayImageUrl
                ? $osscdn(item.displayImageUrl)
                : '/image/static/img/nopic.jpg'
            "
            @click="onImagePreview(index)"
            class="image"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic.jpg" class="image" />
            </div>
          </el-image>
        </div>
        <div class="img-desc">
          {{ item.imgDesc }}
        </div>
      </div>
    </vuedraggable>
    <div class="row" v-if="disabled">
      <div
        v-for="(item, index) in listDetail"
        :key="item.evgPackingSchemeGroupDetailCode"
        class="draggable-item col  fg-0"
      >
        <div class="desc-img">
          <el-image
            :src="
              item.displayImageUrl
                ? $osscdn(item.displayImageUrl)
                : '/image/static/img/nopic.jpg'
            "
            @click="onImagePreview(index)"
            class="image"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic.jpg" class="image" />
            </div>
          </el-image>
        </div>
        <div class="img-desc">
          {{ item.imgDesc }}
        </div>
      </div>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in listDetail"
        :src="item.displayImageUrl || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable'
import EditLoading from '@/mixins/edit-loading'
export default {
  props: {
    evgPackingSchemeGroupCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: { vuedraggable },
  mixins: [EditLoading],
  computed: {
    listImageView() {
      return this.listDetail.map((image) => {
        return image.displayImageUrl
      })
    },
  },
  data() {
    return {
      listDetail: [],
    }
  },
  watch: {
    evgPackingSchemeGroupCode: {
      handler() {
        this.getData()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onImagePreview(index) {
      // 点击大图显示图片预览组件
      if (this.listDetail.length) {
        this.viewer = this.$el.querySelector('.imagesViewer').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    getData() {
      if (!this.evgPackingSchemeGroupCode) return
      this.$api
        .ecomEvgPackingSchemeDescGroupDetailListApi({
          evgPackingSchemeGroupCode: this.evgPackingSchemeGroupCode,
        })
        .then((res) => {
          this.listDetail = res.body.data || []
        })
    },
    draggableEnd({ newIndex, oldIndex }) {
      if (this.disabled) {
        return
      }
      if (newIndex === oldIndex) return
      const oldEl = { ...this.listDetail[oldIndex] }
      if (newIndex < oldIndex) {
        for (let i = oldIndex; i > newIndex; i--) {
          this.listDetail[i] = this.listDetail[i - 1]
        }
      } else if (newIndex > oldIndex) {
        for (let i = oldIndex; i < newIndex; i++) {
          this.listDetail[i] = this.listDetail[i + 1]
        }
      }
      this.listDetail[newIndex] = oldEl
      this.updateSortOrder(this.listDetail)
    },
    updateSortOrder(params) {
      this.loadingOpen()
      this.updateOrder(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
              type: 'success',
            })
            this.getData()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async updateOrder(params) {
      return await this.$api.ecomEvgPackingSchemeDescGroupDetailUpdateSortOrderApi(
        {
          detailList: params,
        }
      )
    },
  },
}
</script>
<style lang="scss" scope>
.fg-0 {
  flex-grow: 0 !important;
}
.desc-img {
  width: 370px;
  height: 190px;
  border-radius: 10px;
  .image {
    width: 370px;
    height: 190px;
    border-radius: 10px;
    > img {
      object-fit: cover;
    }
  }
}
.img-desc {
  width: 370px;
  font-size: 14px;
  color: #101010;
  margin-top: 10px;
}
.draggable-item {
  margin-bottom: 10px;
}
.move {
  cursor: move !important;
}
</style>
